import React from 'react'
import './Footer.css'

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">AllNightAI</h3>
            <p className="footer-description">
              Autonomous development workflows that work while you sleep
            </p>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-heading">Product</h4>
              <ul>
                <li><a href="#features">Features</a></li>
                <li><a href="#integrations">Integrations</a></li>
                <li><a href="#download">Download</a></li>
                <li><a href="#">Pricing</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-heading">Resources</h4>
              <ul>
                <li><a href="#">Documentation</a></li>
                <li><a href="#">API Reference</a></li>
                <li><a href="#">Blog</a></li>
                <li><a href="#">Changelog</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-heading">Company</h4>
              <ul>
                <li><a href="#">About</a></li>
                <li><a href="#">Careers</a></li>
                <li><a href="#">Contact</a></li>
                <li><a href="#">Privacy</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-heading">Community</h4>
              <ul>
                <li><a href="https://github.com/allnightai" target="_blank" rel="noopener noreferrer">GitHub</a></li>
                <li><a href="https://twitter.com/allnightai" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                <li><a href="https://discord.gg/allnightai" target="_blank" rel="noopener noreferrer">Discord</a></li>
                <li><a href="#">Newsletter</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {currentYear} AllNightAI. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#">Terms</a>
            <span>•</span>
            <a href="#">Privacy</a>
            <span>•</span>
            <a href="#">Security</a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
